import { Redirect, useLocalSearchParams } from "expo-router";

import { api } from "~/utils/api";
import { PersonResults } from "~/components/feature/person";
import { MainPageWrapper } from "~/components/layout";

const PersonPage = () => {
  const personId = useLocalSearchParams().personId as string;
  const [organization] = api.organization.get.useSuspenseQuery();

  if (!organization.hasPerPersonView) {
    return <Redirect href="/groups" />;
  }

  return (
    <MainPageWrapper>
      <PersonResults personId={personId} />
    </MainPageWrapper>
  );
};

export default PersonPage;
